var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5858 0L3.5858 8L11.5858 16H7.5858L0.295798 8.71C0.20207 8.61704 0.127675 8.50644 0.0769067 8.38458C0.026138 8.26272 0 8.13201 0 8C0 7.86799 0.026138 7.73728 0.0769067 7.61542C0.127675 7.49356 0.20207 7.38296 0.295798 7.29L7.5858 0H11.5858Z",
    fill: "#FFAF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.5fe3e2fc996b4cff539d2888c8a2b3da.svg";
export { ForwardRef as ReactComponent };